import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import { routes } from './router.js'
import { installShowcaseMocks } from './mocks/showcase.js'
import { bootstrapAttributionFromUrl, initAnalytics, normalizeAnalyticsPath, trackPageview } from './utils/analytics.js'
import { installChunkLoadRecovery } from './utils/chunkLoad.js'
import './style.css'

installShowcaseMocks()

// The router must be INSTALLED (app.use) — RouterView/RouterLink/useRoute
// all resolve through the injections the install provides. Creating the
// router without installing it renders an empty shell.
const router = createRouter({ history: createWebHistory(), routes })

router.afterEach((to) => {
  const canonicalPath = normalizeAnalyticsPath(to.fullPath)
  bootstrapAttributionFromUrl(canonicalPath)
  trackPageview(canonicalPath)
})

initAnalytics(null).catch(() => {})

installChunkLoadRecovery(router)

createApp(App).use(router).mount('#app')
